var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteIconLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000162321975620793188560000012494538798646230171_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 190",
    style: {
      enableBackground: "new 0 0 170 190"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.2,41.8L92.8,2.1C88-0.7,82-0.7,77.2,2.1L7.8,41.8C3,44.6,0,49.7,0,55.3v79.4c0,5.6,3,10.7,7.8,13.5 l69.3,39.7c4.8,2.8,10.8,2.8,15.7,0l69.3-39.7c4.9-2.8,7.8-7.9,7.8-13.5V55.3C170,49.7,167,44.6,162.2,41.8L162.2,41.8z  M139.6,117.3c0,5.6-3,10.7-7.8,13.5l-38.9,22.3c-4.8,2.8-10.8,2.8-15.7,0l-38.9-22.3c-4.8-2.8-7.8-7.9-7.8-13.5V72.7 c0-5.6,3-10.7,7.8-13.5L77.2,37c4.8-2.8,10.8-2.8,15.7,0l38.9,22.3c4.9,2.8,7.8,7.9,7.8,13.5V117.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIconLogo);
export default __webpack_public_path__ + "static/media/white-icon-logo.d4ea7a492f86594e0f4ac63c4fd0ce4e.svg";
export { ForwardRef as ReactComponent };